export class DenialReasonsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDenialReasons() {
    return this.#http.get('/DenialReason');
  }

  async getHMDACodes() {
    return this.#http.get('/DenialReason/hmda-codes');
  }

  async createDenialReason(params) {
    return this.#http.post('/DenialReason', params);
  }

  async editDenialReason(params) {
    return this.#http.put(`/DenialReason`, params);
  }

  async deleteDenialReason({ denialReasonId }) {
    return this.#http.delete(`/DenialReason/${denialReasonId}`);
  }
}
